import { HttpInterceptor, HttpEvent, HttpResponse, HttpHandler, HttpRequest, HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { tap, map } from 'rxjs/operators';
import { ErrorService, Errormessage } from '@app/services/error.service';
import { LoaderService } from '@app/services/loader/loader.service';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
//import { UserManager } from 'oidc-client';
import { AuthService } from '@app/services/auth/auth.service';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
@Injectable()

export class HttpConfigInterceptor implements HttpInterceptor {


  accesstoken;

  // tslint:disable-next-line:max-line-length
  constructor(private errorService: ErrorService, private loaderservice: LoaderService, public http: HttpClient, private authService: AuthService, private router: Router, private messageService: MessageService) {

    this.authService.accesstoken.subscribe(a => {
      if(a) {
        this.accesstoken = a;
        
      }
    });

   }



  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    if (this.accesstoken) {

      request = request.clone({
        setHeaders: {
          authorization: `Bearer ${this.accesstoken}`
        }
      });
    }



    return next.handle(request).pipe(tap(event => {


    }),
      catchError((error: HttpErrorResponse) => {


         if (error.status === 401) {
          //this.authService.startSignoutMainWindow();

          this.router.navigate(['/unauthorized']);
         } else {

         // console.log('INTERCEPTOR:', error.error);
         //test 2021-07-08 this.messageService.add({severity:'error', summary:'Error', detail: error.error, life:7000});
           const err = new Errormessage;
           err.msg = error;
          this.errorService.error.next(err);
          return throwError(error);
        }

      }));


  }

}
